import { Box, Container } from '@chakra-ui/react';
import React from 'react';

import 'react-image-gallery/styles/css/image-gallery.css';

import { VehicleExtended } from '@/types/details-car/details-car.types';

import ImageGallery from '../image-gallery/ImageGallery';

import Styles from './Gallery.module.scss';

const Gallery = ({
  gallery,
  vehicleInfo,
}: {
  gallery: string[];
  vehicleInfo: VehicleExtended;
}) => {
  return (
    <Box className={Styles.galleryWrapper}>
      <Container
        maxW={'1328'}
        width={'100%'}
        paddingX={0}
        paddingTop={{ base: 10, lg: 0 }}
      >
        <ImageGallery gallery={gallery} />

        <Box
          mt={12}
          className={Styles.textContent}
          paddingX={{ base: 6, md: 4, xl: 0 }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: vehicleInfo.description.replace(/\n/g, '<br />'),
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Gallery;
